import 'moment/locale/pt-br'
import 'numeral/locales/pt-br'

import Cookies from 'js-cookie'
import _ from 'lodash'
import numeral from 'numeral'
import stringSimilarity from 'string-similarity'
import Fingerprint2 from 'fingerprintjs2';
import queryString from 'query-string'

import { BCrediLogo, CreditasLogo, GeruLogo } from 'components/partners-list/partners-list.utils'
import { PartnerItem } from 'components/partners-list/partners-list'
import { getUtmSource } from 'providers/profile.provider'
import { ESTIMULO_2020, SEBRAE } from 'constants/constants'
import useReactRouter from 'use-react-router'
import { RouteParams } from 'components/custom-route/custom-route'
import { PaymentInterval as SimulationPaymentInterval } from 'bizcap-commons-web/dist/loan/simulator/simulator';
import { LoanApplication, PaymentInterval } from 'generated/graphql'

numeral.locale('pt-br');

export const formatCnpj = (cnpj: string) => {
    let formattedCnpj = '';

    if (!_.isEmpty(cnpj)) {
        const char = { 2: '.', 5: '.', 8: '/', 12: '-' };

        cnpj = replaceAll(cnpj, '', ..._.values(char));
        for (let i = 0; i < cnpj.length; i++) {
            formattedCnpj += (char[i] || '') + cnpj[i];
        }
    }

    return formattedCnpj;
};

export const formatPhone = (phone: string) => {
    let formattedPhone = '';

    if (!_.isEmpty(phone)) {
        const char = { 0: '(', 2: ') ', 7: '-', };

        phone = replaceAll(phone, '', ..._.values(char));
        for (let i = 0; i < phone.length; i++) {
            formattedPhone += (char[i] || '') + phone[i];
        }
    }

    return formattedPhone;
};

export const formatMoney = (value: number) => (
    value ? numeral(value).format('0,0.00') : '0,00'
);

export const formatMoneyWithoutDecimals = (value: number) => (
    value ? numeral(value).format('0,0') : '0'
);

export function validateEmail(email: string) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const match = email && email.match(regex);
    return (match && match.length > 0) ? true : false;
};

export const replaceAll = (str: string, replace: string, ...find: string[]) => {
    find.forEach(stringToReplace => {
        str = str.replace(new RegExp(_.escapeRegExp(stringToReplace), 'g'), replace);
    });
    return str;
};

export const validateZipCode = (zipCode: string) => {
    const rawZipCode = zipCode.replace(/[^0-9]+/g, '');
    return rawZipCode.length === 8;
};

export const validateObject = (form) => {
    const invalidFields = [];
    const nullableFields = [
        'commission',
        'fixedComission',
        'number',
        'complement',
        'details',
        'interestRate',
        'fixedCommissionPercent',
        'paymentInterval',
        'downPayments'
    ];

    for (const [key, value] of Object.entries<any>(form)) {
        if (nullableFields.includes(key)) {
            continue;
        }

        if ((key === 'paymentDay' || key === 'interestRate') && getUtmSource() === SEBRAE) {
            continue;
        }

        if (key === 'city') {
            if (!value || !value.name) {
                invalidFields.push(key);
            }
            if (!value || !value.state || !value.state.abbreviation) {
                invalidFields.push('state');
            }
        }

        if (key === 'bank') {
            if (!value || !value.code) {
                invalidFields.push(key);
            }
        }

        if (!value) {
            console.log(key);
            invalidFields.push(key);
        }
    }

    return invalidFields;
};

export const sanitizeString = (text: string) => {
    return text ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase() : "";
}

export const handleEnterKey = (event, name: string) => {
    if (event.keyCode === 13) {
        const inputElements = Array.from(document.getElementsByTagName('input'));
        const index = inputElements.findIndex((el) => el.name === name);
        const nextInputElement = inputElements[index + 1];
        if (nextInputElement) {
            nextInputElement.focus();
        } else {
            const nextButton = document.getElementsByName("next-button")[0];
            if (nextButton) {
                nextButton.click()
            }
        }
    }
}

export const matchClosestString = (text: string, arr: string[]) => {
    if (text && arr && arr.length > 0) {
        const matches = stringSimilarity.findBestMatch(text, arr);
        return matches.bestMatch.target;
    }
    return undefined;
}

type option = {
    label: string,
    value: string | number,
};

export const getObjectAsList = (obj: any): option[] => {
    return Object.keys(obj)
        .map((key: string) => ({
            label: obj[key],
            value: key
        }));
};

export const ReactBing = {
    pageview: (path: string): void => {
        const trackKey = 'uetq';

        window[trackKey] = window[trackKey] || [];
        window[trackKey].push({ 'ec': 'pedido', 'ea': 'step', 'el': path, 'ev': 1 });
    },
};

export const checkLoanApplicationId = () => {
    let id = window.location.pathname.split('pedido/bndes/')[1] || null;

    if (!id) {
        id = window.location.pathname.split('pedido/')[1] || null;
    }

    if (id) {
        id = id.split('/')[0];
    }
};

const BREADCRUMBS_SESSION_ID_KEY = 'breadcrumbsSessionId';

type BreadcrumbsSessionIfPresentCallbackProps = {
    sessionId: string;
    key: string;
};

type BreadcrumbsSessionIfPresentCallback = (props: BreadcrumbsSessionIfPresentCallbackProps) => void;

export const BreadcrumbsSession = {
    ifPresent: (callback: BreadcrumbsSessionIfPresentCallback) => {
        const sessionId = Cookies.get(BREADCRUMBS_SESSION_ID_KEY);

        if (sessionId) {
            callback({ sessionId, key: BREADCRUMBS_SESSION_ID_KEY });
        }
    },
    reset: () => Cookies.remove(BREADCRUMBS_SESSION_ID_KEY),
};

export const getFirstName = (name: string): string => name && (name.split(' ')[0]);

export const isIE = () => {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    return false;
}

export const getStorage = () => {
    return localStorage
        || window.localStorage
        || sessionStorage
        || window.sessionStorage;
}

export const calculateFingerPrint = (callback) => {
    setTimeout(() => {
        Fingerprint2.get((components) => {
            const componentsValue = components.map(component => component.value).join('~~~');
            const calculatedFingerPrint = Fingerprint2.x64hash128(componentsValue, 31);
            callback(calculatedFingerPrint);
        });
    }, 500);
}

export const getPartners = (): PartnerItem[] => (
    [
        {
            logo: GeruLogo,
            name: 'geru',
            callToActionUrl: 'https://tracking.geru.com.br/api/v1/tracks?medium=CPA&campaign=btn_card&partner=biz_capital&source=BizCap&redirect=https%3A%2F%2Fwww.geru.com.br%2Femprestimos%2F%3Futm_content%3DBizCap%26utm_source%3DBizCap%26utm_medium%3DBizCap',
            maxRequestedAmount: 'R$ 50 mil',
            terms: '36x',
            guarantee: false,
            operation: 'empréstimo',
            nature: 'física',
            dataCategory: 'Navegação Negado',
            dataLabel: 'link-Geru',
            dataAction: 'Clique /direto/negado'
        },
        {
            logo: CreditasLogo,
            name: 'creditas',
            callToActionUrl: 'https://www.creditas.com.br/emprestimo-online?utm_medium=affiliates&utm_source=bizcapital&utm_campaign=btn_card',
            maxRequestedAmount: 'R$ 3 milhões',
            terms: '240x',
            guarantee: true,
            operation: 'empréstimo',
            nature: 'física',
            dataCategory: 'Navegação Negado',
            dataLabel: 'link-Creditas',
            dataAction: 'Clique /direto/negado'
        },
        {
            logo: BCrediLogo,
            name: 'bcredi',
            callToActionUrl: 'https://simulador.bcredi.com.br/biz-capital?utm_source=biz-capital&utm_medium=keyaccount&utm_campaign=btn_card',
            maxRequestedAmount: 'R$ 4 milhões',
            terms: '180x',
            guarantee: true,
            operation: 'empréstimo',
            nature: 'física e jurídica',
            dataCategory: 'Navegação Negado',
            dataLabel: 'link-Bcredi',
            dataAction: 'Clique /direto/negado'
        },
    ]
)

export const getTrackingInfo = () => {
    const queryParams = getQueryParamsAsJson() as any;

    if(queryParams && queryParams.utm_source === 'sebrae') {
        queryParams.utm_source = 'live_sb';
    }

    return JSON.stringify(
        Object.assign(getCookieAsJson(), queryParams)
    );
}

export const getQueryParamsAsJson = () => {
    const obj = {};

    window.location.search.substring(1).split("&")
        .filter((pair: string) => pair !== '')
        .map((pair: string) => {
            try {
                return decodeURIComponent(pair).split("=");
            } catch (error) {
                if (error instanceof URIError) {
                    return decodeURIComponent(pair.replace('%', '')).split("=");
                }

                throw error;
            }
        })
        .forEach(([ key, value ]) => {
            obj[key] = value;
        });

    return obj;
}

export const getCookieAsJson = () => (
    document.cookie.split('; ').reduce((prev, current) => {
        const [name, value] = current.split('=');
        prev[name] = value;
        return prev
    }, {})
);

export const getRandomNumber = (min: number, max: number) => (
    Math.trunc(Math.random() * (max - min) + min)
);

export const getQueryParamFromSearch = (param: string): string => {
    const result = queryString.parse(location.search)[param];

    return result ? String(result) : null;
};

export const isIosDevice = () => (
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
);

export const isSafariBrowser = () => (
    /Version\/[\d\.]+.*Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor)
);

/**
 * returns the key name by the value
 * @param {object} object
 * @param {string} value
 * @return {string} returns the found key
 */
export function getKeyByValue(object: object, value: string): string {
    return Object.keys(object).find(key => object[key] === value);
}

export const getLoanApplicationParams = () => {
    const { match: { params: { loanApplicationId } } } = useReactRouter<RouteParams>();

    return loanApplicationId;
}

export const convertToSimulationPaymentInterval = (
    paymentInterval?: PaymentInterval | null
) => {
    const enumMap: Record<PaymentInterval, SimulationPaymentInterval> = {
        [PaymentInterval.Weekly]: SimulationPaymentInterval.Weekly,
        [PaymentInterval.Monthly]: SimulationPaymentInterval.Monthly
    };

    if (paymentInterval == null) return SimulationPaymentInterval.Monthly;

    return enumMap[paymentInterval];
};

export const getMaxTenure = (
    loanApplication: LoanApplication,
    productMaxTenure: number
) : number => {
    if (
        loanApplication.product.bizId === ESTIMULO_2020 &&
        (loanApplication?.acceptedProposal?.downPayments > 0 ||
        loanApplication?.lastProposal?.downPayments > 0)
    ) {
        return 30;
    }

    return productMaxTenure;
}
